import { defineSlotRecipe } from '@chakra-ui/react';
import { dropdownBg, raisedShadow } from '../themeColor';

/** Popover and context-menu shells. Same paper and edge as text fields. */
export const popoverSlotRecipe = defineSlotRecipe({
  slots: ['content'],
  base: {
    content: {
      borderWidth: 'hairline',
      borderColor: 'border',
      bg: dropdownBg,
      boxShadow: raisedShadow,
    },
  },
  variants: {
    variant: {
      menu: {
        content: {
          borderRadius: 'lg',
        },
      },
      panel: {
        content: {
          borderRadius: 'lg',
        },
      },
      elevated: {
        content: {
          bg: 'bgElevated',
          borderRadius: 'xl',
          boxShadow: '2xl',
          outline: 'none',
        },
      },
    },
  },
  defaultVariants: {
    variant: 'menu',
  },
});
